import SupervisorLayout from '../../components/layout/SupervisorLayout';
import AnnouncementsManager from '../../components/AnnouncementsManager';

export default function SupervisorAnnouncementsPage() {
  return (
    <SupervisorLayout>
      <AnnouncementsManager />
    </SupervisorLayout>
  );
}
